/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Solitaire/ChallengeMode',{
    None: 0,
    DailyChallenge: 1,
    StarClub: 2
});
